/** Per-browser lists: recently visited issues and the last issue list (for « » navigation). */
import { useSyncExternalStore } from 'react';

const RECENT_KEY = 'bt.recent';
const LIST_KEY = 'bt.lastList';
const listeners = new Set<() => void>();

function read<T>(storage: Storage | undefined, key: string, fallback: T): T {
  try {
    const v = storage?.getItem(key);
    return v ? (JSON.parse(v) as T) : fallback;
  } catch {
    return fallback;
  }
}
function write(storage: Storage | undefined, key: string, value: unknown) {
  try {
    storage?.setItem(key, JSON.stringify(value));
  } catch {
    /* storage unavailable */
  }
}
const local = () => (typeof localStorage === 'undefined' ? undefined : localStorage);
const session = () => (typeof sessionStorage === 'undefined' ? undefined : sessionStorage);

let recentCache = read<number[]>(local(), RECENT_KEY, []);

export function addRecent(id: number) {
  recentCache = [id, ...recentCache.filter((x) => x !== id)].slice(0, 5);
  write(local(), RECENT_KEY, recentCache);
  listeners.forEach((l) => l());
}

export function useRecent(): number[] {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => recentCache,
  );
}

/** Remember the ids of the issue list the user is looking at. */
export function setLastList(ids: number[]) {
  write(session(), LIST_KEY, ids);
}

export function neighbours(id: number): { prev?: number; next?: number } {
  const ids = read<number[]>(session(), LIST_KEY, []);
  const i = ids.indexOf(id);
  if (i < 0) return {};
  return { prev: ids[i - 1], next: ids[i + 1] };
}
